// extracted by mini-css-extract-plugin
export default {"previewEmpty":"RecorderPreview_previewEmpty__ZNYlq"};